import { Card, CardContent } from '@mui/material';
import React from 'react';
import CustomBarChart from '../../../../components/Charts/custom-barchart';
import TableEmptyData from '../../../table/TableEmptyData';

export default function WarehouseStockDistribution({ data }) {
   // Format data for the chart and filter out warehouses with 0 stock
   const formattedData = data && data.length > 0
      ? data
         .filter(item => parseInt(item.total_stock) > 0) // Only show warehouses with stock
         .map(item => ({
            name: item.warehouse || 'Unknown',
            value: parseInt(item.total_stock) || 0 // Use "value" as the key because that's what CustomBarChart expects
         }))
      : [];

   return (
      <Card>
         <CardContent className="!p-0">
            <div className="flex justify-between items-center pl-6 pr-3 py-4">
               <div className="flex items-center">
                  <span className="text-xl font-medium">
                     Stock Distribution by Warehouse
                  </span>
               </div>
            </div>
            {formattedData.length > 0 ? (
               <div className="px-4 pb-4">
                  <CustomBarChart
                     data={formattedData}
                     dataKey="name"
                     barChartList={[  // "barChartList" not "barList"
                        { dataKey: 'value', name: 'Stock Quantity', color: '#240B3B' }
                     ]}
                     showLegend={true}
                     barSize={40}
                  />
               </div>
            ) : (
               <div className="border border-x-0 border-b-0 mb-10">
                  <TableEmptyData content="warehouse distribution data" />
               </div>
            )}
         </CardContent>
      </Card>
   );
}